import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { localizePath } from "@/lib/localeRoutes";

const steps = ["request", "accept", "visit"] as const;

export const VisitJourney = () => {
  const { t, i18n } = useTranslation("doctorVisits");

  return (
    <section id="visit-journey" tabIndex={-1} className="bg-secondary px-4 py-20 text-secondary-foreground sm:px-6 sm:py-24 lg:px-8">
      <div className="mx-auto max-w-[1168px]">
        <div className="max-w-3xl">
          <p className="text-sm font-semibold uppercase tracking-[0.16em] text-primary">
            {t("journey.eyebrow")}
          </p>
          <h2 className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl">
            {t("journey.title")}
          </h2>
          <p className="mt-5 text-lg leading-8 text-secondary-foreground/70">
            {t("journey.description")}
          </p>
        </div>

        <ol className="mt-14 grid gap-10 md:grid-cols-3 md:gap-8">
          {steps.map((step) => (
            <li key={step} className="border-t border-secondary-foreground/20 pt-6">
              <span className="text-sm font-semibold tracking-[0.14em] text-primary">
                {t(`journey.steps.${step}.number`)}
              </span>
              <h3 className="mt-7 text-xl font-semibold leading-8">
                {t(`journey.steps.${step}.title`)}
              </h3>
              <p className="mt-3 leading-7 text-secondary-foreground/70">
                {t(`journey.steps.${step}.description`)}
              </p>
            </li>
          ))}
        </ol>

        <Link
          to={localizePath("/how-it-works", i18n.language)}
          className="mt-12 inline-flex min-h-11 items-center gap-2 font-semibold text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-4 focus-visible:ring-offset-secondary"
        >
          {t("journey.fullProcessLink")}
          <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </div>
    </section>
  );
};
